import request from '@/utils/request';

//报名表
export function getApplyTable(params){
  return request({
      url: '/api/v1/apply/apply_table',
      method: 'get',
      params
  });
};
//下载报名表
export function downApplyTable(params){
  return request({
      url: '/api/v1/apply/down_apply_table',
      method: 'get',
      params
  });
};
//两证
export function getTicket(params){
  return request({
      url: '/api/v1/apply/ticket_view',
      method: 'get',
      params
  });
};
//打印准考证 通知书
export function downApplyTicket(params){
  return request({
      url: '/api/v1/apply/down_apply_ticket',
      method: 'get',
      params,
  });
};

//报名表单
export function getTable(params){
  return request({
      url: '/api/v1/apply/apply_view',
      method: 'post',
      data: params
  });
};
//改报/重报(修改信息)
export function applyJobs(params){
  return request({
      url: '/api/v1/apply/apply_jobs',
      method: 'post',
      data: params
  });
};
//改报列表
export function getJobsList(params){
  return request({
      url: '/api/v1/apply/getJobsList',
      method: 'get',
      params
  });
};

//改报
export function editApply(params){
  return request({
      url: '/api/v1/apply/edit_apply',
      method: 'post',
      data: params
  });
};
//报名数据
export function getApplyData(params){
  return request({
      url: '/api/v1/apply/getApplyData',
      method: 'get',
      params
  });
};


// WEBPACK FOOTER //
// ./src/api/apply.js